import { TerritoryData } from "../../../domain/models/territory-data";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { RemoteFetchRegionMaster } from "../../../data/usecases/remote-fetch-region";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { StateCreator } from "zustand";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";


export interface FetchRegionMasterInterface {
  regionMasterData: TerritoryData[];
  fetchRegionMaster: Function;
  clearRegionMaster: Function;
}

const intitalValue = {
  regionMasterData: [],
};
const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchRegionMasterSlice: StateCreator<
  FetchRegionMasterInterface
> = (set) => ({
  ...intitalValue,
  fetchRegionMaster: async (id: number[]) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchRegionMaster = new RemoteFetchRegionMaster(
      `${BASE_URL}${Endpoints.FETCH_REGION_MASTER}`,
      axiosHttpClient
    );
    const payload = { zone_ids: id };
    let result = await remoteFetchRegionMaster.fetch(payload);
    if (result) {
      set(() => ({ regionMasterData: result.regions }));
    }
  },
  clearRegionMaster: () => {
    set(() => ({ regionMasterData: [] }));
  },
});
